import { Directive, HostBinding } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingActionGrouped]',
    standalone: false
})
export class ListingActionGroupedDirective extends TemplateRefDirective {
    @HostBinding('class.action-grouped-section') addClass = true;
}
